"use runtime-nodent"

import init from "init/application"
import "static/static"
// Shared carousel styles - imported before components so component overrides take precedence
import "utils/_carousel.scss"
import "components/location-breadcrumbs/location-breadcrumbs"
import locationSubnavigation from "components/location-subnavigation/location-subnavigation"
import forecastUserControl from "components/forecast-user-control/forecast-user-control"
import "components/affiliate-fillers/affiliate-fillers"
import "components/gallery-photo-upload/gallery-photo-upload"
import "components/affiliate-banner-header/affiliate-banner-header"
import "components/panel/panel"
import "components/elevation-with-mountain/elevation-with-mountain" // TODO: is it used somewhere?
import liveSnow from "components/live-snow/live-snow"
import scrollButton from "components/scroll-button/scroll-button"
import switchUnits from "components/switch-units"
import forecastTable from "components/forecast-table"
import "components/incentive/incentive"
import "components/premium-incentive/premium-incentive"
import "components/about-resort-forecast/about-resort-forecast"
import "components/snow-alert-subscription/snow-alert-subscription"
import "components/resort-rating/resort-rating"
import "components/resort-review/resort-review"
import snowhist from "components/snowhist"
import reviewVotes from "components/review-votes/review-votes"
import reviewSortLinks from "components/review-sort-links/review-sort-links"
import snowConditions from "components/snow-conditions/snow-conditions"
import "components/resort-snow-report/resort-snow-report"
import "components/resort-snowfall-snippet/resort-snowfall-snippet"
import "components/resort-snow-depths-snippet/resort-snow-depths-snippet"
import "components/resort-condition/resort-condition"
import "components/stars-bar/stars-bar"
import resortNearbyResorts from "components/resort-nearby-resorts/resort-nearby-resorts"
import "components/elevation-mountain/elevation-mountain"
import "components/ski-discount-table/ski-discount-table"
import "components/ski-hire-iframe/ski-hire-iframe"
import "components/ski-hire-directory/ski-hire-directory"
import "components/ski-hire-promo/ski-hire-promo"
import "components//ski-hire-bar"
import "components//intersport-voucher"
import "components//alpine-fleet-widget"
import "components/easter-header/easter-header"
import "components/easter-infographic/easter-infographic"
import "components/resort-tab-header/resort-tab-header"
import rewardsHeader from "components/rewards-header/rewards-header"
import "components/resort-guide/resort-guide"
import "components/resort-guide-text"
import "components/app-promo"
import collapsible from "components/collapsible/collapsible"
import gallerySortLinks from "components/gallery-sort-links/gallery-sort-links"
import "components/advertise-header/advertise-header"
import "components/advertise-contact/advertise-contact"
import "components/advertise-markets/advertise-markets"
import "components/media-kit/media-kit"
import moneySavingTips from "components/money-saving-tips/index"
import initTooltip from "components/tooltips"
import "components/closing-infographics"
import "components/hindcast-prompt"
import scrollFade from "components/scroll-fade"
import { Nearby } from "components/nearby"
import { Carousel } from "components/carousel"
import "components/distance-range-slider"
import "components/snow-icon"
import "components/snow-icon-static"

import resortWebcams from "components/resort-webcams/resort-webcams"
import { WindIcon } from "components/wind-icon"
import "components/weather-icon"
import asideMenu from "components/aside-menu/aside-menu"
import offCanvasSearch from "components/off-canvas-search/off-canvas-search"
import modalLoginBox from "components/modal-login-box/modal-login-box"
import login from "components/login/login"
import "components/login"
import galleryPhoto from "components/gallery-photo"
import "components/intersport-discount-page"
import "components/intersport-discount-page/promo-article"

import "components/buttons"
import "components/app-buttons"
import "components/outside-buttons"
import "components/apple-buttons"
import "components/google-buttons"
import "components/gallery-thumbnails"
import "components/gallery-upload-button"
import "components/votes-bar"
import "components/comment-votes"
import "components/pagination"
import "components/picks"
import "components/featured-photos"
import "components/outside-promo-page"
import "components/outside-page"
import "components/nearest-ski-resorts-with-webcams"
import { Smartbar } from "components/smartbar"
import { ModalAppPopup } from "components/modal-app-popup"
import { Weski } from "components/weski"
import { Signup } from "components/signup-page"
import signup from "components/signup"
import rewards from "components/rewards"

import { ResortFinder } from "components/resort-finder"
import "components/flag"
import { Buttons } from "components/controls"
import "components/star-rating"

import snowReportPage from "components/snow-report-page"
import snowHistoryPage from "components/snow-history"
import { Map } from "components/leaflet"
import "components/snow-amount"
import { PageHeader } from "components/page-header"
import "components/page-footer"
import "components/homepage-hero"
import "components/user-avatar"
import { AccordionReviews } from "components/accordion-reviews"
import "components/carousel-news-posts"
import { FeatureNewsPosts } from "components/feature-news-posts"
import "components/carousel-resort-picks"
import "components/carousel-photo-gallery"
import "components/promo-premium"
import "components/promo-app"
import "components/snow-maps-seo-section"

// Temporary from NL
// import { Footer } from "components/nl/page-footer"

// eslint-disable-next-line import/first, import/no-unresolved
import "fc-ads/fc-ads.scss"

const meta = document.querySelector("meta[name=csrf-token]")
const token = meta ? meta.content : ""

const runOnInteractive = async () => {
  init()
  scrollFade()
  locationSubnavigation()
  switchUnits()
  forecastTable()
  forecastUserControl()
  liveSnow()
  snowhist()
  scrollButton()
  reviewVotes()
  reviewSortLinks()
  snowConditions()
  resortNearbyResorts()
  snowReportPage()
  snowHistoryPage()
  collapsible()
  gallerySortLinks()
  resortWebcams()
  WindIcon.init(document, {})
  initTooltip()
  Nearby.init(document.body, {})
  Smartbar.init(document.body)
  ModalAppPopup.init(document.body)
  Signup.init(document.body)
  Carousel.init(document.body)
  AccordionReviews.init(document.body)
  Buttons.init(document.body)
  ResortFinder.init(document.body)
  FeatureNewsPosts.init(document.body)
}

const runOnLoad = () => {
  rewards()
  signup()
  moneySavingTips()
  rewardsHeader()
  asideMenu()
  offCanvasSearch()
  modalLoginBox()
  login()
  galleryPhoto({
    token,
    loggedIn: window.FCGON.logged_in,
    memberMode: window.FCGON.member_mode,
    location: window.FCGON.location_filename,
  })
  Map.init(document.body, {
    level: window.FCGON.level,
    isMemberMode: window.FCGON.member_mode,
    mapConfigList: window.FCGON.maps,
  })
  PageHeader.init(document.body)
  // Footer.init(document.body)
  Weski.init(document.body)
}

// `DOMContentLoaded` may fire before your script has a chance to run, so check before adding a listener
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runOnInteractive)
} else {
  // `DOMContentLoaded` already fired
  runOnInteractive()
}

if (document.readyState === "loading" || document.readyState === "interactive") {
  window.addEventListener("load", runOnLoad)
} else {
  // window.load already fired
  runOnLoad()
}
